import { useMemo } from 'react'
import { appPath, sgBaseUrl } from '@fs/zion-config'
import { useUser } from '@fs/zion-user'
import { useQuery } from '@tanstack/react-query'
import axios from '../utils/giveAxios'

const groupReportsUrl = `${sgBaseUrl}/service/records/volunteer/orchestration/user/authorization/reports/groups`
// toggle these two lines to test the whitelist locally without needing to use a local redis server
// don't forget to change the whitelistUrl back to the first value before committing
const whitelistUrl = `${appPath}/reports-whitelist`
// const whitelistUrl = `https://integration.familysearch.org/getinvolved/reports-whitelist`

const whiteListKey = 'reports-whitelist'
const groupReportsKey = 'reports-group-reports'

export default function useReportsAccess() {
  const { cisId, signedIn, userLoading } = useUser()

  const whitelistEnabled = signedIn && !groupReportsUrl.includes('sg31b0') && !userLoading
  const groupReportsEnabled = signedIn && !groupReportsUrl.includes('sg31b0') && !userLoading && !!cisId

  const {
    data: whitelistData,
    isLoading: whitelistLoading,
    error: whitelistError,
  } = useQuery({
    queryKey: [whiteListKey],
    queryFn: () => axios.get(whitelistUrl, { headers: { 'x-fs-feature-tag': 'a02j000000BZ3ZTAA1' } }),
    enabled: whitelistEnabled,
    cacheTime: 1000 * 60 * 60,
    staleTime: Number.POSITIVE_INFINITY,
  })

  const {
    data: groupReportsData,
    isLoading: groupReportsLoading,
    error: groupReportsError,
  } = useQuery({
    queryKey: [groupReportsKey],
    queryFn: () => axios.get(groupReportsUrl),
    enabled: groupReportsEnabled,
    cacheTime: 1000 * 60 * 60,
  })

  const { authorized, loading, units } = useMemo(() => {
    if (
      (!signedIn && userLoading) ||
      (whitelistEnabled && whitelistLoading) ||
      (groupReportsEnabled && groupReportsLoading)
    )
      return { authorized: true, loading: true, units: [] }
    if (groupReportsEnabled) {
      return { authorized: !!groupReportsData?.data?.length, units: groupReportsData?.data || [], loading: false }
    }
    if (whitelistEnabled) {
      return { authorized: !!whitelistData?.data?.length, units: whitelistData?.data || [], loading: false }
    }
    return { authorized: false, units: [], loading: false }
  }, [
    signedIn,
    userLoading,
    whitelistEnabled,
    whitelistLoading,
    groupReportsEnabled,
    groupReportsLoading,
    groupReportsData,
    whitelistData,
  ])

  return {
    authorized,
    data: units,
    error: groupReportsError || whitelistError,
    loading,
  }
}
